export default __webpack_public_path__ + "static/media/logo.0f575ad7.png";